module.exports = __webpack_public_path__ + "static/media/Vector.f6fd840b.svg";